"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toast = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _drywall = require("drywall");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _constants = require("../../constants");
var _ToastMixin = require("../../mixins/components/ToastMixin");
var _statusIconAppearance = require("../../util/statusIconAppearance");
var _CloseButton = require("../CloseButton/CloseButton");
var _excluded = ["inverse"];
/**
 * Toasts use the `ToastProvider` component to
 * manage the state of all toasts  within the application. _Always_ use toasts with
 * `ToastProvider`, _never_ embed a toast directly into the content of a page. For inline
 * status messages, you can use the `Alert` or `InlineFeedback` components.
 *
 * @related ['Alert', 'Banner', 'InlineFeedback']
 * @subcomponents ['ToastProvider']
 * @since 7.4.0
 */
var Toast = /*#__PURE__*/(0, _styledComponents.default)(function (_ref) {
  var inverse = _ref.inverse,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_drywall.Toast, rest);
}).withConfig({
  displayName: "Toast",
  componentId: "c11n-8-107-0__sc-18t8o9m-0"
})(["", ""], _ToastMixin.ToastMixin);
exports.Toast = Toast;
Toast.displayName = 'Toast';
Toast.propTypes = {
  /**
   * An optional action button.
   */
  actionButton: _propTypes.default.node,
  /**
   * The type of toast to display.
   *
   * Note: The `appearance` value can modify component content such as `icon`,
   * as well as behavior such as the `duration` it is visible with `ToastProvider`.
   */
  appearance: _propTypes.default.oneOf(Object.values(_constants.STATUS_TYPES)),
  /**
   * The body content of the toast message.
   */
  body: _propTypes.default.node,
  /**
   * In general, you will want to use the `body` prop,
   * but you can use the children prop to override the default component layout.
   * When passing a function, the function will receive all the component props as the only
   * argument (Note: some of the props may have been modified and/or enhanced,
   * so you should always use the values that are passed to the render function).
   */
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  /**
   * The close button node. You can set this to null to remove the close button from the toast.
   */
  closeButton: _propTypes.default.node,
  /**
   * The icon node. By default, this will use an icon based on the toast `appearance`.
   */
  icon: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  /**
   * Toasts are a controlled component where the `isOpen` prop controls the visibility.
   */
  isOpen: _propTypes.default.bool,
  /**
   * Function called with the `closeButton` is clicked.
   */
  onClose: _propTypes.default.func,
  /**
   * Toasts should have a role of [status](https://www.w3.org/TR/wai-aria-1.1/#status) or
   * [alert](https://www.w3.org/TR/wai-aria-1.1/#alert) to signal assistive technologies
   * that it requires the user's attention. In general, you will always want to use the less
   * strict "status" role.
   */
  role: _propTypes.default.oneOf(['status', 'alert'])
};
Toast.defaultProps = {
  appearance: 'info',
  closeButton: /*#__PURE__*/_react.default.createElement(_CloseButton.CloseButton, null),
  icon: _statusIconAppearance.statusIconAppearance
};

/** @component */